// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UDJT9","field":"styles_field__3nfa5","fieldCol":"styles_fieldCol__2EfOH","diffCol":"styles_diffCol__4frPR","diff":"styles_diff__1Jwqa"};